"use client";

import { Container } from "react-bootstrap";
import { Accordion } from "react-bootstrap";

const FaqContent = () => {
  // Static data for FAQ items
  const faqData = [
    {
      question: "این سامانه حساب اعتباری چیه؟",
      answer:
        "یک سیستم توزیع هوشمند اعتبار آنلاین که کاربران می توانند در فروشگاه های طرف قرارداد بصورت اعتباری خرید انجام دهند.",
    },
    {
      question: "امکانات سامانه چیست؟",
      answer:
        "این سامانه به فروشگاه های طرف قرارداد امکانت ثبت پرداخت سفارش مشتری بصورت اعتباری را می‌دهد.",
    },
    {
      question: "این سامانه مخصوص چه کسب و کارهایی هست؟",
      answer:
        "کاربردی برای هر فروشگاه یا ارائه دهنده خدماتی که بخواهد از جامعه کاربران سامانه حساب اعتباری بهره مند شود.",
    },
    {
      question: "نیازمندی عضویت و استفاده چی هست؟",
      answer:
        "بستن قرارداد با تعاونی فرهنگیان بوئین و میاندشت و داشتن یک گوشی موبایل برای ثبت پرداخت فاکتور مشتریان توسط اعتبار.",
    },
  ];

  return (
    <div className="faq-area position-relative z-1 pt-125">
      <Container>
        <div className="section-title mw-630">
          <span className="top-title">
            <span>FAQ</span>
          </span>
          <h2>سؤالات کاربردی: چه سؤالی داری؟</h2>
        </div>

        <Accordion defaultActiveKey="0" className="faq-wrapper mw-740 m-auto">
          {faqData.map((item, index) => (
            <Accordion.Item
              eventKey={index.toString()}
              key={index}
              className="mb-3 border-0 bg-white"
            >
              <Accordion.Header>
                <div
                  style={{
                    fontWeight: "600",
                    fontSize: "16px",
                  }}
                >
                  {item.question}
                </div>
              </Accordion.Header>
              <Accordion.Body>{item.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </div>
  );
};

export default FaqContent;
